import { render } from "./NcrmNotificationRow.vue?vue&type=template&id=41ad2d0c&scoped=true"
import script from "./NcrmNotificationRow.vue?vue&type=script&lang=js"
export * from "./NcrmNotificationRow.vue?vue&type=script&lang=js"

import "./NcrmNotificationRow.vue?vue&type=style&index=0&id=41ad2d0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ad2d0c"]])

export default __exports__